export default __webpack_public_path__ + "static/media/mussen-nest-logo-light.a29506c4.svg";